import { render, staticRenderFns } from "./PersonProfileMasterLocationInfo.vue?vue&type=template&id=ef1019d6&scoped=true&"
import script from "./PersonProfileMasterLocationInfo.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterLocationInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileMasterLocationInfo.vue?vue&type=style&index=0&id=ef1019d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1019d6",
  null
  
)

export default component.exports